"use client";

import Link from "next/link";
import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import { ArrowRight } from "@/components/icons";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";
import { CONTACT_SALES_URL } from "@/lib/constants";

interface Props {
  description: string;
}

// German clone of src/components/ui/enterprise-banner — same layout, the
// "Enterprise"/"Talk to Sales" strings there are hardcoded with no override
// prop, so this mirrors the component rather than wrapping it.
export default function EnterpriseBannerDe({ description }: Props) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      initial={prefersReducedMotion ? false : { opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={scrollRevealViewport}
      transition={{ duration: 0.45 }}
      className="border-border bg-card relative flex flex-col items-start justify-between gap-5 overflow-hidden rounded-xl border p-7 sm:flex-row sm:items-center"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          background:
            "radial-gradient(ellipse at 20% 50%, color-mix(in srgb, var(--foreground) 4%, transparent) 0%, transparent 60%)",
        }}
        aria-hidden="true"
      />
      <div className="relative">
        <p className="text-muted-foreground mb-1 text-xs font-semibold">Enterprise</p>
        <h3 className="text-foreground mb-1 text-lg font-bold">Individuellen Plan benötigt?</h3>
        <p className="text-muted-foreground text-sm">{description}</p>
      </div>
      <Link
        href={CONTACT_SALES_URL}
        className={cn(
          buttonVariants({ variant: "outline", size: "default" }),
          "relative shrink-0 font-semibold"
        )}
      >
        Vertrieb kontaktieren
        <ArrowRight size={14} className="ml-1.5" aria-hidden="true" />
      </Link>
    </motion.div>
  );
}
